import { calcSizeString, isImageFormat, resizeImage } from "@/helpers/fileHelper";
import * as LOG from "@/log";
import { Get, Post, Delete } from "@/services/Server";
import URL from "@/services/urls";
import useFilesStore, { UploadableFile } from "@/store/files";
import { ChatWidgetActionRequest } from "@/TickApi";


export async function createFile(file: UploadableFile, chatWidgetId: string, to: string, newMessageId: string): Promise<ChatWidgetActionRequest> {
    try {
        LOG.debugApi(`[Files:Upload] Start for ${file.name} `);
        let fileData: Blob = file.file;
        if (isImageFormat(file.name)) {
            LOG.debugApi(`[Files:RESIZE]Resizing attachment ${file.name} `);
            resizeImage(file.file, 1000, 1000).then((d) => {
                fileData = d;
                LOG.debugApi(`[Files:RESIZE]resize attachment complete, from ${calcSizeString(file.file.size, 2)} to ${calcSizeString(d.size, 2)}`);
            })

        }

        const formData = new FormData()
        formData.append('file', fileData)

        useFilesStore().setUploadProgress(file.id, 0);

        const uploadConfig = {
            onUploadProgress: function (progressEvent) {
                const percentCompleted = Math.ceil((progressEvent.loaded / progressEvent.total) * 100);
                useFilesStore().setUploadProgress(file.id, percentCompleted);
            }
        }

        const response = await Post<ChatWidgetActionRequest>(URL.uploadFile.toString() + `/${chatWidgetId}/${to}/${newMessageId}`, formData, uploadConfig);
        return response.data;
    } catch (error) {
        LOG.error('Error while creating file', { error });
        throw new Error(`Error while creating a file ${JSON.stringify(error)}`);
    }
}
